import axios from 'axios';
import { buildApiUrl } from '../config/api';

export const DistritoService = {
  fetchDistritosPorProvincia: async (token, provinceId) => {
    try {
      const response = await axios.get(buildApiUrl(`/api/locations/districts/${provinceId}`), {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });

      if (response.data.success) {
        return response.data.data;
      } else {
        console.error("La API no devolvió success=true para distritos");
        return [];
      }
    } catch (error) {
      console.error("Error en DistritoService.fetchDistritosPorProvincia:", error);
      throw error;
    }
  },
};
